<template>
  <div class="ui modal" ref="modal">
    <i class="close icon"></i>
    <div class="header">{{ $t("pensum") }}</div>
    <div class="image scrolling content">
      <div class="ui mini image">
        <img src="images/icons/graduate.png" />
      </div>
      <div class="description">
        <div class="ui form">
          <div class="field">
            <label for="">{{ $t("name") }}</label>
            <input type="text" name="name" v-model="d.name" />
          </div>
          <p></p>
        </div>
        <div class="field">
          <label>{{ $t("career") }}</label>
          <div
            class="ui fluid multiple search selection dropdown"
            ref="carreer_dropdown"
          >
            <input type="hidden" name="carreer" />
            <i class="dropdown icon"></i>
            <div class="default text">{{ $t("select one") }}</div>
            <div class="menu"></div>
          </div>
        </div>
        <p></p>
        <p>
          <distribution ref="distribution" />
        </p>
      </div>
    </div>
    <div class="actions">
      <div class="ui black deny button">{{ $t("cancel") }}</div>
      <div class="ui positive right labeled icon button" @click="ok">
        {{ $t("ok") }}
        <i class="checkmark icon"></i>
      </div>
    </div>
  </div>
</template>

<script>
import { local_api, error_toast } from "@/utils";

import Distribution from "./Distribution.vue";

export default {
  components: {
    Distribution,
    // DocumentTypes
  },
  computed: {},
  data() {
    return {
      d: {
        name: "",
        id: "",
      },
      courses: [],
      careers: [],
    };
  },
  methods: {
    showModal(pensum) {
      let vm = this;

      // console.log(pensum);

      if (pensum) {
        vm.d.name = pensum.name;
        vm.d.id = pensum.uuid;

        local_api(vm, "post", "/pensum/do-get-detail", {
          uuid: pensum.uuid,
          // u: vm.d.id,
        })
          .then((resp) => {
            // console.log(resp);
            vm.$refs.distribution.setDistribution(
              resp.pnm_pensum_distributions,
            );

            let assignations = resp.pnm_pensum_assignations.map((a) => {
              return a.career_id;
            });

            vm.careers = assignations.join(",");
            window
              .jQuery(vm.$refs.carreer_dropdown)
              .dropdown("set selected", assignations);
          })
          .catch((err) => {
            error_toast(err);
          });
      }

      window
        .jQuery(vm.$refs.modal)
        .modal({
          onHidden() {
            vm.d = {
              name: "",
              id: "",
            };
            vm.careers = "";
            vm.$refs.distribution.clear();

            window.jQuery(vm.$refs.carreer_dropdown).dropdown("clear");
          },
        })
        .modal("show");
    },
    ok() {
      let vm = this;
      let courses = vm.$refs.distribution.getList();
      local_api(vm, "post", "/pensum/do-save", {
        d: {
          name: vm.d.name,
          i: vm.d.id,
          courses: courses,
          careers: vm.careers,
        },
        // u: vm.d.id,
      })
        .then((resp) => {
          console.log(resp);
        })
        .catch((err) => {
          error_toast(err);
        });
    },
  },
  mounted() {
    let vm = this;
    local_api(vm, "post", "/student_configuration/do-get-configuration", {})
      .then((resp) => {
        // console.log(resp);
        let carreers = resp.std_careers
          ? resp.std_careers.map((b) => {
              return { value: b.career_id, name: b.name };
            })
          : [];
        // console.log(carreers);

        window
          .jQuery(vm.$refs.carreer_dropdown)
          .dropdown({
            onChange: function(value) {
              vm.careers = value;
            },
          })
          .dropdown("setup menu", { values: carreers });
      })
      .catch((err) => {
        error_toast(err);
      });
  },
  watch: {},
  updated: function() {},
};
</script>
